import { render, staticRenderFns } from "./screenshots.vue?vue&type=template&id=21f130a6&scoped=true"
import script from "./screenshots.vue?vue&type=script&lang=js"
export * from "./screenshots.vue?vue&type=script&lang=js"
import style0 from "./screenshots.vue?vue&type=style&index=0&id=21f130a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f130a6",
  null
  
)

export default component.exports